import * as _encoding2 from "lib0/encoding";
var _encoding = "default" in _encoding2 ? _encoding2.default : _encoding2;
import * as _decoding2 from "lib0/decoding";
var _decoding = "default" in _decoding2 ? _decoding2.default : _decoding2;
import * as _sync2 from "y-protocols/sync";
var _sync = "default" in _sync2 ? _sync2.default : _sync2;
import * as _awareness2 from "y-protocols/awareness";
var _awareness = "default" in _awareness2 ? _awareness2.default : _awareness2;
import * as _auth2 from "y-protocols/auth";
var _auth = "default" in _auth2 ? _auth2.default : _auth2;
import * as _broadcastchannel2 from "lib0/broadcastchannel";
var _broadcastchannel = "default" in _broadcastchannel2 ? _broadcastchannel2.default : _broadcastchannel2;
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
  n,
  t = _encoding,
  r = _decoding,
  a = _sync,
  s = _awareness,
  i = _auth,
  c = _broadcastchannel;
function o() {
  return (o = Object.assign ? Object.assign.bind() : function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }).apply(this, arguments);
}
!function (e) {
  e[e.Sync = 0] = "Sync", e[e.Awareness = 1] = "Awareness", e[e.Auth = 2] = "Auth", e[e.QueryAwareness = 3] = "QueryAwareness";
}(n || (n = {}));
var d = ((e = {})[n.Sync] = function (e, r, s, i) {
  t.writeVarUint(e, n.Sync);
  var c = a.readSyncMessage(r, e, s.doc, s);
  i && c === a.messageYjsSyncStep2 && !s.synced && (s.synced = !0);
}, e[n.QueryAwareness] = function (e, r, a, i, c) {
  t.writeVarUint(e, n.Awareness), t.writeVarUint8Array(e, s.encodeAwarenessUpdate(a.awareness, Array.from(a.awareness.getStates().keys())));
}, e[n.Awareness] = function (e, n, t) {
  s.applyAwarenessUpdate(t.awareness, r.readVarUint8Array(n), t);
}, e[n.Auth] = function (e, n, t) {
  i.readAuthMessage(n, t.doc, function (e, n) {
    return function (e, n) {
      console.warn("Permission denied to access " + e.channelName + ".\n" + n);
    }(t, n);
  });
}, e);
exports.WebsocketProvider = function () {
  function e(e, r, i, o, d) {
    var u = this,
      h = void 0 === d ? {} : d,
      l = h.awareness,
      w = void 0 === l ? new s.Awareness(e) : l,
      y = h.disableBc,
      p = void 0 !== y && y;
    this.bcSubscriber = function (e, n) {
      if (n !== u) {
        var r = u.process(new Uint8Array(e), !1);
        t.length(r) > 1 && c.publish(u.bcChannelName, t.toUint8Array(r), u);
      }
    }, this.updateHandler = function (e, r) {
      if (r !== u) {
        var s = t.createEncoder();
        t.writeVarUint(s, n.Sync), a.writeUpdate(s, e), u.send(t.toUint8Array(s));
      }
    }, this.unloadHandler = function () {
      s.removeAwarenessStates(u.awareness, [u.doc.clientID], "window unload");
    }, this.awarenessUpdateHandler = function (e, r) {
      var a = e.removed,
        i = e.added.concat(e.updated).concat(a),
        c = t.createEncoder();
      t.writeVarUint(c, n.Awareness), t.writeVarUint8Array(c, s.encodeAwarenessUpdate(u.awareness, i)), u.send(t.toUint8Array(c));
    }, this.consumer = r, this.channelName = i, this.bcChannelName = i + "_" + Object.entries(o).map(function (e, n) {
      return e + "-" + n;
    }).join("_"), this.params = o, this.doc = e, this.awareness = w, this.bcconnected = !1, this.disableBc = p, this._synced = !1, this.doc.on("update", this.updateHandler), "undefined" != typeof window ? window.addEventListener("unload", this.unloadHandler) : "undefined" != typeof process && process.on("exit", this.unloadHandler), w.on("update", this.awarenessUpdateHandler), this.connect();
  }
  var i,
    u,
    h = e.prototype;
  return h.destroy = function () {
    this.disconnect(), "undefined" != typeof window ? window.removeEventListener("unload", this.unloadHandler) : "undefined" != typeof process && process.off("exit", this.unloadHandler), this.awareness.off("update", this.awarenessUpdateHandler), this.doc.off("update", this.updateHandler);
  }, h.send = function (e) {
    var n,
      t,
      r = (t = Array.from(e, function (e) {
        return String.fromCharCode(e);
      }).join(""), btoa(t));
    null == (n = this.channel) || n.send({
      update: r
    }), this.bcconnected && c.publish(this.bcChannelName, e, this);
  }, h.process = function (e, n) {
    var a = r.createDecoder(e),
      s = t.createEncoder(),
      i = r.readVarUint(a),
      c = d[i];
    return c ? c(s, a, this, n, i) : console.error("Unable to compute message"), s;
  }, h.subscribe = function () {
    var e = this;
    this.synced = !1, this.channel = this.consumer.subscriptions.create(o({
      channel: this.channelName
    }, this.params), {
      received: function (n) {
        var r = function (e) {
            return Uint8Array.from(atob(e), function (e) {
              return e.charCodeAt(0);
            });
          }(n.update),
          a = e.process(r, !0);
        t.length(a) > 1 && e.send(t.toUint8Array(a));
      },
      disconnected: function () {
        e.synced = !1, s.removeAwarenessStates(e.awareness, Array.from(e.awareness.getStates().keys()).filter(function (n) {
          return n !== e.doc.clientID;
        }), e);
      },
      connected: function () {
        var r = t.createEncoder();
        if (t.writeVarUint(r, n.Sync), a.writeSyncStep1(r, e.doc), e.send(t.toUint8Array(r)), null !== e.awareness.getLocalState()) {
          var i = t.createEncoder();
          t.writeVarUint(i, n.Awareness), t.writeVarUint8Array(i, s.encodeAwarenessUpdate(e.awareness, [e.doc.clientID])), e.send(t.toUint8Array(i));
        }
      }
    });
  }, h.connectBc = function () {
    if (!this.disableBc) {
      this.bcconnected || (c.subscribe(this.bcChannelName, this.bcSubscriber), this.bcconnected = !0);
      var e = t.createEncoder();
      t.writeVarUint(e, n.Sync), a.writeSyncStep1(e, this.doc), c.publish(this.bcChannelName, t.toUint8Array(e), this);
      var r = t.createEncoder();
      t.writeVarUint(r, n.Sync), a.writeSyncStep2(r, this.doc), c.publish(this.bcChannelName, t.toUint8Array(r), this);
      var i = t.createEncoder();
      t.writeVarUint(i, n.QueryAwareness), c.publish(this.bcChannelName, t.toUint8Array(i), this);
      var o = t.createEncoder();
      t.writeVarUint(o, n.Awareness), t.writeVarUint8Array(o, s.encodeAwarenessUpdate(this.awareness, [this.doc.clientID])), c.publish(this.bcChannelName, t.toUint8Array(o), this);
    }
  }, h.disconnectBc = function () {
    var e = t.createEncoder();
    t.writeVarUint(e, n.Awareness), t.writeVarUint8Array(e, s.encodeAwarenessUpdate(this.awareness, [this.doc.clientID], new Map())), this.send(t.toUint8Array(e)), this.bcconnected && (c.unsubscribe(this.bcChannelName, this.bcSubscriber), this.bcconnected = !1);
  }, h.disconnect = function () {
    var e;
    this.disconnectBc(), null == (e = this.channel) || e.unsubscribe(), null != this.channel && (this.channel = void 0);
  }, h.connect = function () {
    null == this.channel && (this.subscribe(), this.connectBc());
  }, i = e, (u = [{
    key: "synced",
    get: function () {
      return this._synced;
    },
    set: function (e) {
      this._synced !== e && (this._synced = e);
    }
  }]) && function (e, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, "symbol" == typeof (a = function (e, n) {
        if ("object" != typeof e || null === e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var r = t.call(e, "string");
          if ("object" != typeof r) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(r.key)) ? a : String(a), r);
    }
    var a;
  }(i.prototype, u), Object.defineProperty(i, "prototype", {
    writable: !1
  }), e;
}();
//# sourceMappingURL=actioncable.cjs.production.min.js.map
export default exports;